<bw-header-label-cell-legacy
  @fadeIn
  [labelCellConfig]="payrollPendingCellConfig"
></bw-header-label-cell-legacy>
